import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { ModalStore } from '../../state/ModalStore'

function ModalMainWrapper({ children, show = true, zIndexClass = 'z-[60]' }) {
    const skim = ModalStore((state) => state.skim)
    return (
        <Transition appear show={show} as={Fragment}>
            <Dialog
                as="div"
                className={`fixed inset-0 ${zIndexClass} overflow-y-auto`}
                onClose={skim}>
                <div className="min-h-screen px-[18px] py-[34px] text-center sm:px-6">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0">
                        <Dialog.Overlay className="fixed inset-0 bg-[rgba(26,29,35,0.55)] backdrop-blur-[2px]" />
                    </Transition.Child>

                    <span
                        className="inline-block min-h-screen align-middle"
                        aria-hidden="true">
                        &#8203;
                    </span>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-200"
                        enterFrom="opacity-0 translate-y-2 scale-[0.99]"
                        enterTo="opacity-100 translate-y-0 scale-100"
                        leave="ease-in duration-150"
                        leaveFrom="opacity-100 translate-y-0 scale-100"
                        leaveTo="opacity-0 translate-y-2 scale-[0.99]">
                        {children}
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition>
    )
}

export default ModalMainWrapper
